export * from './fast-access-tab-menu.component';
